import { ModelDataService } from './../../base-services/model-data.service';
import { map, switchMap } from 'rxjs/operators';
import { Subscription, Observable, of } from 'rxjs';
import { AuthenticationService } from './../../base-services/authentication.service';
import { ConfigService } from './../../base-services/config.service';
import { BaseDataService } from './../../base-services/base-data.service';
import { CollectionService } from './../../base-services/collection.service';
import { OrgJedView } from '../../base-models/org-jed-view';
import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
//import { CollectionService, BaseDataService, QueryParameter, ConfigService, AuthenticationService, ModalService } from 'yt-ng-framework';
import { Router, ActivatedRoute } from '@angular/router';
import { QueryParameter } from '../../base-models/query-parameter';
import { List } from 'immutable';
import { ModalService } from '../../base-services/modal.service';

@Component({
    selector: 'company-selector',
    templateUrl: './company-selector.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompanySelectorComponent {
     constructor(
         public collectionService: CollectionService,
         protected baseDataService: BaseDataService,
         protected router: Router,
         protected configService: ConfigService,
         protected authenticationService: AuthenticationService,
         protected activatedRoute: ActivatedRoute,
         protected changeDetectorRef: ChangeDetectorRef,
         protected modalService: ModalService,
         protected modelDataService: ModelDataService
     ){
     }

     rootItems: List<OrgJedView>;
     childItems: List<OrgJedView>;
     selectedRootItem: OrgJedView;
     selectedChildItem: OrgJedView;
     selectedItem: OrgJedView = null;
    
     modelProperty: string = 'Naziv';
     orderBy: string = 'Naziv';
     isRootControlDisabled: boolean;
     isChildControlDisabled: boolean;

     selectingOrgJed: boolean = false;

     private selectedOrgJed;
     private queryParams;

     private activatedRouteSubscription: Subscription;

     ngOnInit(){
         this.loadRootItems();        
         this.configService.SelectedOrgJed
             .subscribe(selectedOrgJed => {
                 this.selectedOrgJed = selectedOrgJed;
             })
         this.activatedRouteSubscription = this.activatedRoute.queryParams
             .subscribe(queryParams => {
                 this.queryParams = queryParams;
             })
     }

     private loadRootItems(){
         this.baseDataService.Get('orgJed', 'getRootByUser', [], OrgJedView)
             .subscribe((data) => {
                 if(!data || data.length == 0){
                    //this.showRegisterCompanyModal();
                    this.hasCompany();
                    return;
                 }

                 this.rootItems = this.collectionService.SortItems(List(data), this.orderBy, false);
                 if(this.selectedOrgJed && this.rootItems.filter(orgJed => orgJed.ID == this.selectedOrgJed.ID).size > 0){
                     this.selectedRootItem = this.rootItems.filter(orgJed => orgJed.ID == this.selectedOrgJed.ID).get(0);
                     this.selectedItem = this.selectedRootItem;
                     this.loadChildItems(this.selectedRootItem.ID);
                 }
                 else if(this.selectedOrgJed && this.selectedOrgJed.ParentOrgJed && this.rootItems.filter(orgJed => orgJed.ID == this.selectedOrgJed.ParentOrgJed.ID).size > 0){
                     this.selectedRootItem = this.rootItems.filter(orgJed => orgJed.ID == this.selectedOrgJed.ParentOrgJed.ID).get(0);
                     this.selectedItem = this.selectedRootItem;
                     this.loadChildItems(this.selectedRootItem.ID);
                 }
                 else if(this.rootItems == null || this.rootItems.size <= 1){
                     this.selectedRootItem = this.rootItems != null && this.rootItems.size > 0 ? this.rootItems.get(0) : null;
                     this.isRootControlDisabled = true;
                     this.onRootItemChanged(this.selectedRootItem);
                     
                 }
                 this.changeDetectorRef.markForCheck();
             })
     }

     onRootItemChanged(rootItem: OrgJedView){
         this.selectedItem = this.selectedRootItem;
         this.loadChildItems(this.selectedRootItem.ID);
     }

     private loadChildItems(ID: number){
         if(ID == null)
             return;
         let parameters: QueryParameter[] = [];
         let parameter: QueryParameter = new QueryParameter();
         parameter.Name = 'parentID';
         parameter.Value = ID;
         parameters.push(parameter);
         this.baseDataService.Get('orgJed', 'getByUserAndParent', parameters, OrgJedView)
             .subscribe((data: OrgJedView[]) => {
                 this.isChildControlDisabled = false;
                 this.childItems = this.collectionService.SortItems(List(data), this.orderBy, false);
                 //if(this.childItems == null || this.childItems.size <= 1){
                     //this.selectedChildItem = this.childItems != null && this.childItems.size > 0 ? this.childItems.get(0) : this.selectedRootItem;
                     //this.isChildControlDisabled = true;
                     //this.onChildItemChanged(this.selectedChildItem);
                 //}
                 //else if(this.selectedOrgJed && this.queryParams.returnUrl){
                     //this.selectedChildItem = this.selectedOrgJed;
                     //this.onChildItemChanged(this.selectedOrgJed);
                 //}
                 if(this.selectedOrgJed && this.childItems.filter(orgJed => orgJed.ID == this.selectedOrgJed.ID).size > 0){
                     this.selectedChildItem = this.childItems.filter(orgJed => orgJed.ID == this.selectedOrgJed.ID).get(0);
                     this.selectedItem = this.selectedChildItem;
                 }
                 else if(this.childItems == null || this.childItems.count() == 0){
                     this.selectedItem = this.selectedRootItem;
                     this.isChildControlDisabled = true;
                     //this.selectOrgJed();
                    //this.selectedChildItem = this.selectedRootItem;
                    //this.onChildItemChanged(this.selectedChildItem);
                 }
                 if(this.rootItems.count() == 1 && (this.childItems == null || this.childItems.count() <= 1)) {
                    if (this.childItems.get(0))
                    {
                        this.selectedItem = this.childItems.get(0);
                    }
                    this.selectOrgJed();
                 }
                 this.changeDetectorRef.markForCheck();
             })
     }

     onChildItemChanged(childItem: OrgJedView){
         //localStorage.setItem('selOrgJed', JSON.stringify(childItem));
         //this.configService.SetSelectedOrgJed(childItem);
         //this.authenticationService.ChangeOrgJed(this.selectedChildItem)
             //.subscribe(data => {
                 //this.router.navigate(['/']);
             //})

        this.selectedItem = this.selectedChildItem;
        this.selectedItem.ParentOrgJed = this.selectedRootItem;
        //this.selectOrgJed();
     }

     selectOrgJed(){
         this.selectingOrgJed = true;
        this.authenticationService.ChangeOrgJed(this.selectedItem)
            .subscribe(data => {
                this.router.navigate(['/']);
            }, (error) => {
                this.selectingOrgJed = false;
                this.changeDetectorRef.markForCheck();
                throw error;
            })
        this.authenticationService.CheckLicenseExpiration(this.selectedItem)
            .subscribe(()=>{})
     }

     clearSelection(){
         this.selectedChildItem = null;
         this.selectedItem = this.selectedRootItem ? this.selectedRootItem : this.selectedChildItem;
     }

     private showRegisterCompanyModal(){
        //this.hasCompany()
            //.subscribe
        let modelData = this.modelDataService.GetModelDataByPath('firma-register');
        this.modalService.ShowModal(-1, modelData, null, false, null)
            .result
                .then(() => {
                }, reason => {})
     }

     private hasCompany() {
         return this.baseDataService.Get('user', 'hasCompany', [], null)
            .subscribe(hasCompany => {
                if(hasCompany){
                    alert('Obratite se podršci')
                    return;
                }
                this.showRegisterCompanyModal();
            })
     }
}